// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2KFMz","image":"_3s2Ra","read-more":"_25poH","content":"_2FuPS","more":"_1TUmr"};